<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    destroy-on-close
    :append-to-body="appendToBody"
    :modal-append-to-body="appendToBody"
    @close="$emit('close')"
    width="1000px"
  >
    <template #title>
      <div class="d-flex justify-content-between">
        <div style="display: flex; align-items: center; justify-content: space-between">
          <strong style="font-size: 16px; margin-right: 10px; color: #42444d"
            >Tạo quy trình mới</strong
          >
        </div>
        <div v-if="appendToBody">
          <el-button
            icon="el-icon-plus"
            plain
            @click="navigateToFieldSetup"
            style="font-size: 14px; margin-left: 60px"
            >Thêm trường dữ liệu</el-button
          >
        </div>
      </div>
    </template>
    <div class="d-flex justify-content-between" style="background-color: #fafafa">
      <div class="ms-3 mb-2 mt-1">
        <ValidationObserver ref="obs">
          <div class="mt-2 required">Tên quy trình</div>
          <ValidationProvider
            name="Tên quy trình"
            rules="required-input: tên quy trình"
            v-slot="{ errors }"
          >
            <el-input
              class="counter-pad"
              maxlength="200"
              show-word-limit
              v-model="formData.processName"
              style="width: 320px"
              placeholder="Nhập tên quy trình"
            />
            <div v-if="errors[0]" class="mt-1 ms-1">
              <InputError :message="errors[0]" />
            </div>
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <div class="me-2 mb-2 mt-1">
        <div class="mt-2">Mô tả</div>
        <el-input
          class="counter-pad"
          maxlength="256"
          show-word-limit
          v-model="formData.processDescription"
          style="width: 560px"
          placeholder="Mô tả quy trình"
        />
      </div>
    </div>
    <div class="mt-2 ms-3">
      <div class="pb-1">
        <p class="mb-2">
          Tài liệu đính kèm <span>({{ files.length }})</span>:
        </p>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex" style="position: relative">
            <div
              class="d-flex justify-content-between align-items-center gap-2 me-2"
              v-for="file in files.slice(0, 2)"
              :key="file.name"
            >
              <div class="upload-input">
                <div class="d-flex align-items-center">
                  <div class="material-icons" style="font-size: 16px">
                    attach_file
                  </div>
                  <span class="text-ellipsis">{{ file.name }}</span>
                  <div @click="removeFile(file)" style="cursor: pointer">
                    <IconFont name="icon-close" color="#327AE7" />
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="files.length > 2"
              class="upload-input more-files me-2"
              style="width: 45px;"
              @click="openFile"
            >
              +{{ files.length - 2 }}
            </div>
            <div class="open-file" v-if="isOpen">
              <div
                class="d-flex justify-content-between align-items-center gap-2 me-2 mb-2"
                v-for="file in files.slice(2, files.length)"
                :key="file.name"
              >
                <div class="upload-input">
                  <div class="d-flex align-items-center">
                    <div class="material-icons" style="font-size: 16px">
                      attach_file
                    </div>
                    <span class="text-ellipsis">{{ file.name }}</span>
                    <div @click.stop  ="removeFile(file)" class="close-file" style="cursor: pointer">
                      <IconFont name="icon-close" color="#327AE7" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex w-100 pe-2" @click="$refs.files.click()">
            <div
              class="upload-input d-flex align-items-center justify-content-between"
            >
              Tải tệp đính kèm
              <IconFont :color="'#327AE7'" :name="'icon-import'" />
            </div>
          </div>
          <input
            style="display: none; width: 0; height: 0"
            ref="files"
            type="file"
            multiple
            accept=".pdf,.doc,.docx,.txt,.xls,.xlsx,.csv,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.zip,.rar"
            @change="fileSelected"
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <div class="process ms-3 mt-1">
        <div
          class="d-flex justify-content-between mt-2 ms-2 me-2 mb-2 align-items-center"
        >
          <div class="required d-flex align-items-center">
            Bước quy trình
            <el-tooltip placement="top">
              <div slot="content">
                <strong>Đang xử lý:</strong> Khách đang xử lý, chưa có kết quả<br/>
                <strong>Thành công:</strong> Chốt thành công, tối đa 1 bước<br/>
                <strong>Thất bại:</strong> Từ chối / mất liên lạc
              </div>
              <i class="el-icon-question text-muted ms-1" style="font-size: 14px; cursor: pointer;"></i>
            </el-tooltip>
          </div>
          <button class="custom-button-add" @click="addSteps">
            <icon-font
              :name="'icon-add'"
              :color="'white'"
              style="font-size: 13px"
            ></icon-font>
          </button>
        </div>
        <div style="max-height: 200px; overflow-y: auto">
          <draggable
            v-model="formData.workflowDTOS"
            handle=".drag-handle"
            tag="div"
            animation="200"
            @end="updateIndexes"
          >
            <div v-for="(workflow, index) in formData.workflowDTOS" :key="index">
              <ValidationObserver ref="obs">
                <ValidationProvider
                  name="Tên bước"
                  rules="required-input: tên bước"
                  v-slot="{ errors }"
                >
                  <div class="mb-2">
                    <div class="w-100 d-flex align-items-center">
                      <div class="drag-handle ms-2" style="cursor: pointer">
                        <IconFont :name="'icon-organise'" />
                      </div>
                      <div class="custom-item ms-2">
                        <div
                          class="circle"
                          :class="{
                            active: activeIndex === index,
                            value: workflow.title,
                            bolded: boldedIndexes.includes(index),
                          }"
                          style="cursor: pointer"
                          @click.stop="toggleBolded(index)"
                        >
                          {{ workflow.index }}
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between custom-input ms-2"
                        :class="{ 'active-input': activeIndex === index }"
                      >
                        <div
                          style="
                            position: relative;
                            border: none;
                            background: transparent;
                            flex-grow: 1;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <input
                            placeholder="Nhập tên bước"
                            class="custom-input1"
                            v-model="workflow.title"
                            style="border: none; outline: none; background: transparent; padding-right: 70px;"
                            @focus="activeIndex = index"
                            @input="workflow.title = workflow.title.slice(0, 200)"
                            maxlength="200"
                          />
                          <span
                          class="char-counter"
                          style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%);"
                          >
                            {{ workflow.title.length }}/200
                          </span>
                        </div>
                        <el-select
                          v-model="workflow.milestoneType"
                          size="mini"
                          clearable
                          placeholder="Chọn nhóm"
                          style="width: 120px; margin-right: 15px; position: relative; top: -2px;"
                          :class="'milestone-select-' + (workflow.milestoneType || 'EMPTY')"
                          @change="(val) => handleMilestoneChange(index, val, formData.workflowDTOS)"
                          :disabled="index === 0"
                          :popper-append-to-body="appendToBody"
                        >
                          <el-option label="Đang xử lý" value="OPEN" class="bg-open-option" />
                          <el-option label="Thành công" value="WON" class="bg-won-option" />
                          <el-option label="Thất bại" value="LOST" class="bg-lost-option" />
                        </el-select>
                        <div class="color-picker">
                          <el-dropdown trigger="click">
                            <button class="custom">
                              <div
                                class="selected-color"
                                :style="{ backgroundColor: workflow.color }"
                              ></div>
                            </button>
                            <el-dropdown-menu slot="dropdown">
                              <div class="color-container">
                                <div
                                  v-for="color in colors"
                                  :key="color"
                                  @click="handleSelect(color, workflow)"
                                  class="color-box"
                                  :style="{
                                    backgroundColor: color,
                                    color: getTextColor(color),
                                  }"
                                ></div>
                              </div>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <button
                        @click="removeSteps(index)"
                        style="
                          background-color: transparent;
                          border: none;
                          cursor: pointer;
                        "
                      >
                        <icon-font :name="'icon-close'"></icon-font>
                      </button>
                    </div>

                    <div v-if="errors[0]" class="mb-1" style="margin-left: 87px">
                      <InputError :message="errors[0]" />
                    </div>
                  </div>
                </ValidationProvider>
              </ValidationObserver>
            </div>
          </draggable>
        </div>
        <div class="ms-2 mb-2 mt-3 d-flex align-items-center legend-container" style="font-size: 13px; color: #696b72; font-weight: 500;">
           <div class="legend-item d-flex align-items-center"><span class="legend-dot bg-open-dot"></span> Đang xử lý</div>
           <div class="legend-item d-flex align-items-center ms-3"><span class="legend-dot bg-won-dot"></span> Thành công (tối đa 1)</div>
           <div class="legend-item d-flex align-items-center ms-3"><span class="legend-dot bg-lost-dot"></span> Thất bại</div>
        </div>
      </div>
      <div class="information-file me-2 mt-1">
        <div class="d-flex flex-column ms-2">
          <ValidationObserver ref="obs">
            <div
              class="d-flex justify-content-between align-items-center mt-2"
              style="font-size: 14px"
            >
              <div class="required">Trường dữ liệu</div>
              <div class="me-2">
                {{ formData.workflowDTOS[displayIndex]?.columnList?.length }}
              </div>
            </div>
            <ValidationProvider
              name="Trường dữ liệu"
              rules="required-select: trường dữ liệu"
              v-slot="{ errors }"
            >
              <div style="max-height: 200px; overflow-y: auto">
                <el-checkbox-group
                  v-if="formData?.workflowDTOS[displayIndex]"
                  v-model="selectedColumnList"
                  class="checkbox-vertical"
                >
                  <el-checkbox
                    v-for="(info, index) in columnList.filter(c => !['createAt', 'contactWorkflow'].includes(c.name))"
                    :key="index"
                    :label="info.name"
                    :disabled="info.name ==='displayName' || info.name ==='phone'"
                  >
                    {{ info.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div v-if="errors[0]" class="mt-1 ms-4">
                <InputError :message="errors[0]" />
              </div>
            </ValidationProvider>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end">
      <div class="d-flex mt-2" style="margin-right: 15px; margin-bottom: 8px">
        <el-button @click="$emit('close')" plain>Hủy</el-button>
        <el-button
          type="primary"
          @click="submit"
          :disabled="
            !formData.processName ||
            formData?.workflowDTOS?.length == 0 ||
            formData.workflowDTOS.some((wf) => !wf.title?.trim()) ||
            formData.workflowDTOS.some((cl) => !cl.columnList?.length)
          "
          >Tạo quy trình</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { HTTP } from "@/lib/http-common";
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  beforeDestroy() {
    this.dialogVisible = false;
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    initial: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: true,
      items: [1],
      colors: [
        "#5692AD",
        "#D08B20",
        "#0A58C0",
        "#DD7236",
        "#598C78",
        "#B666AA",
        "#3A4660",
        "#466D34",
        "#C84837",
        "#7053B4",
      ],
      selected: [],
      fields: [],
      activeIndex: 0,
      boldedIndexes: [],
      selectedWorkflow: 0,
      formData: {
        processId: "",
        processName: "",
        processDescription: "",
        source: "USER",
        workflowDTOS: [
          {
            index: 1,
            title: "Khách hàng",
            color: "#0A58C0",
            columnList: ["displayName","phone"],
            milestoneType: "OPEN"
          }
        ],
      },
      workflowIndex: 0,
      files: [],
      isOpen: false,
    };
  },
  methods: {
    // formatColumnList() {
    //   this.formData.workflowDTOS.forEach((workflow) => {
    //     workflow.columnList = this.columnList.filter((col) => col.require === true)
    //     .map((col) => col.name);
    //   });
    // },
    updateIndexes() {
      this.formData.workflowDTOS.forEach((workflow, i) => {
        workflow.index = i + 1;
      });
    },
    handleSelect(color, workflow) {
      workflow.color = color;
    },
    getTextColor(bgColor) {
      return this.isDark(bgColor) ? "#ffffff" : "#000000";
    },
    isDark(color) {
      const r = parseInt(color.substr(1, 2), 16);
      const g = parseInt(color.substr(3, 2), 16);
      const b = parseInt(color.substr(5, 2), 16);
      return r * 0.299 + g * 0.587 + b * 0.114 < 128;
    },
    navigateToFieldSetup() {
      this.$emit("switch-to-field-setup");
    },
    handleMilestoneChange(index, newVal, workflowList) {
      if (!newVal) {
        workflowList[index].milestoneType = null;
        return;
      }
      if (newVal === 'WON') {
        workflowList.forEach((wf, i) => {
          if (i !== index && wf.milestoneType === 'WON') {
            wf.milestoneType = 'OPEN';
          }
        });
      }
    },
    addSteps() {
      const maxIndex = this.formData.workflowDTOS.length
        ? Math.max(...this.formData.workflowDTOS.map((item) => item.index))
        : 0;
        // const requiredColumns = this.columnList
        // .filter((col) => col.require)
        // .map((col) => col.name);  
      this.formData.workflowDTOS.push({
        title: "",
        color: this.colors[Math.floor(Math.random() * this.colors.length)],
        index: maxIndex + 1,
        columnList:['displayName','phone'],
        milestoneType: null
      });
    },

    removeSteps(index) {
      if (this.formData.workflowDTOS.length > 1){
        this.formData.workflowDTOS.splice(index, 1);
        this.formData.workflowDTOS.forEach((item, i) => {
        item.index = i + 1;
      });
        this.boldedIndexes = this.boldedIndexes
          .filter((i) => i !== index)
          .map((i) => (i > index ? i - 1 : i));
        if (this.activeIndex === index) {
          this.activeIndex = Math.max(0, index - 1);
        } else if (this.activeIndex > index) {
          this.activeIndex -= 1;
        }
      }

    },
    toggleBolded(index) {
      const pos = this.boldedIndexes.indexOf(index);
      if (pos === -1) {
        this.boldedIndexes = [...this.boldedIndexes, index];
      } else {
        this.boldedIndexes = this.boldedIndexes.filter((i) => i !== index);
      }
    },
    async submit() {
      try {
        const checkWon = this.formData.workflowDTOS.filter(wf => wf.milestoneType === 'WON');
        if (checkWon.length === 0) {
          this.$message.warning("Mỗi quy trình phải có ít nhất 1 bước có Nhóm trạng thái (Milestone) là 'Thành công'.");
          return;
        }

        const titles = this.formData.workflowDTOS.map((item) => item.title.trim());
        const hasDuplicateTitles = titles.some(
          (title, index) => titles.indexOf(title) !== index
        );
        if (hasDuplicateTitles) {
          this.$message.error("Tên bước đã bị trùng. Vui lòng thử lại.");
          return;
        }
        
        const res = await HTTP.post("/api/process/add-process", this.formData);
        if (res.status === "success") {
          this.$message.success("Thêm quy trình thành công!");
          this.$emit("close");
          this.$emit("success", this.formData);
          
          await this.uploadFiles(res.data[0].processId);
          this.updateProcessFileIds(res.data[0].processId);
        } else {
          this.$message.error(res.error.message);
        }
      } catch (error) {
        console.error("Error create process", error);
      }
    },
    async updateProcessFileIds(processId) {
      let payloadUpdate = {};
      payloadUpdate.id = processId;
      payloadUpdate.name = this.formData.processName;
      payloadUpdate.fileIds = this.formData.fileIds
      await HTTP.post("/api/process/update-process", payloadUpdate);
    },
    async uploadFiles(processId) {
      const uploadUrl = this.getUploadUrl(processId);

      for (const file of this.files) {
        const formData = new FormData();
        formData.append("file", file);
        try {
          const res = await HTTP.post(uploadUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (res.status === "success") {
            const newFileIds = res.data;

            if (this.formData.fileIds) {
              this.formData.fileIds += "," + newFileIds.join(",");
            } else {
              this.formData.fileIds = newFileIds.join(",");
            }
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          this.alert("error", "Tải lên thất bại");
        }
      }
    },
    getUploadUrl(processId) {
      let HOST = "https://contact.salework.net";
      // let HOST = "http://localhost:9090";
      // if (Config.DEV) {
      //   HOST = "http://localhost:9090";
      // } else {
      //   HOST = "https://zalo.salework.net";
      // }
      return HOST + "/api/contact-file/upload-process?processId=" + processId;
    },
    handleClickOutside(event) {
      if (
        this.isOpen &&
        !this.$el.querySelector(".open-file")?.contains(event.target) &&
        !this.$el.querySelector(".more-files")?.contains(event.target)
      ) {
        this.isOpen = false;
      }
    },
    openFile() {
      this.isOpen = !this.isOpen;
    },
    removeFile(file) {
      const index = this.files.indexOf(file);
      if (index !== -1) {
        this.files.splice(index, 1);
        if(this.files.length == 2){
          this.isOpen = false
        }
      }
    },
    fileSelected(e) {
      if (!e.target.files || e.target.files.length === 0) return;

      const MAX_FILE_SIZE = 10 * 1024 * 1024;
      const MAX_FILE_COUNT = 20;
      const MAX_TOTAL_SIZE = 100 * 1024 * 1024;
      const WARNING_SIZE = 5 * 1024 * 1024;

      const allowedExt = [
        'pdf', 'doc', 'docx', 'txt',
        'xls', 'xlsx', 'csv',
        'ppt', 'pptx',
        'jpg', 'jpeg', 'png', 'gif',
        'zip', 'rar'
      ];

      const selectedFiles = Array.from(e.target.files);

      const errors = [];
      const warnings = [];

      let totalSize = this.files.reduce((s, f) => s + f.size, 0);
      let addedCount = 0;

      const remainingSlots = MAX_FILE_COUNT - this.files.length;

      for (const file of selectedFiles) {
        const ext = file.name.split('.').pop().toLowerCase();

        if (!allowedExt.includes(ext)) {
          continue;
        }

        if (this.files.some(f => f.name === file.name && f.size === file.size)) {
          errors.push(`${file.name}: File đã tồn tại`);
          continue;
        }

        if (file.size > MAX_FILE_SIZE) {
          errors.push(
            `${file.name}: Dung lượng ${(file.size / 1024 / 1024).toFixed(1)}MB vượt quá 10MB`
          );
          continue;
        }

        if (addedCount >= remainingSlots) {
          warnings.push(`Đã đạt giới hạn ${MAX_FILE_COUNT} file`);
          break;
        }

        if (totalSize + file.size > MAX_TOTAL_SIZE) {
          e.push(`Tổng dung lượng vượt quá 100MB`);
          break;
        }

        if (file.size > WARNING_SIZE) {
          warnings.push(
            `${file.name}: File lớn (${(file.size / 1024 / 1024).toFixed(1)}MB)`
          );
        }

        this.files.push(file);
        totalSize += file.size;
        addedCount++;
      }

      this.showMessage(errors, warnings);
      this.$refs.files.value = "";
    },
    showMessage(errors = [], warnings = []) {
      let html = '';

      if (errors.length) {
        html += `
          <div style="margin-bottom:8px;">
            <strong style="color:#f56c6c; display:flex; align-items:center; gap:6px; margin-bottom:7px">
              <svg width="14" height="14" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="12" fill="#f56c6c"/>
                <rect x="11" y="5" width="2" height="10" rx="1" fill="#fff"/>
                <circle cx="12" cy="18" r="1.5" fill="#fff"/>
              </svg>
              Lỗi:
            </strong>
            <ul>
              ${errors.map(e => `<li style="margin-bottom:5px">${e}</li>`).join('')}
            </ul>
          </div>
        `;
      }

      if (warnings.length) {
        html += `
          <div>
            <strong style="color:#e6a23c;">⚠️ Cảnh báo:</strong>
            <ul style="margin-top: 7px">
              ${warnings.map(w => `<li style="margin-bottom:5px">${w}</li>`).join('')}
            </ul>
          </div>
        `;
      }

      if (!html) return;

      this.$message({
        type: 'success',
        dangerouslyUseHTMLString: true,
        message: html,
        duration: 5000,
        customClass: 'no-icon-message'
      });
    }
  },
  computed: {
    displayIndex() {
      if (this.boldedIndexes.length && this.boldedIndexes.includes(this.activeIndex)) {
        return Math.min(...this.boldedIndexes);
      }
      return this.activeIndex;
    },
    selectedColumnList: {
      get() {
        return this.formData.workflowDTOS[this.displayIndex]?.columnList || [];
      },
      set(newList) {
        const next = Array.isArray(newList) ? newList : [];
        if (this.boldedIndexes.length && this.boldedIndexes.includes(this.activeIndex)) {
          this.boldedIndexes.forEach((idx) => {
            if (this.formData.workflowDTOS[idx]) {
              this.$set(this.formData.workflowDTOS[idx], 'columnList', [...next]);
            }
          });
        } else if (this.formData.workflowDTOS[this.activeIndex]) {
          this.$set(this.formData.workflowDTOS[this.activeIndex], 'columnList', [...next]);
        }
      },
    },
  },
  created() {
    if (this.initial) {
      if (this.initial.processName) this.formData.processName = this.initial.processName;
      if (this.initial.processDescription) this.formData.processDescription = this.initial.processDescription;
      if (this.initial.source) this.formData.source = this.initial.source;
      if (Array.isArray(this.initial.workflowDTOS) && this.initial.workflowDTOS.length) {
        this.formData.workflowDTOS = this.initial.workflowDTOS.map((s, i) => ({
          index: i + 1,
          title: s.title || '',
          color: s.color || '#0A58C0',
          columnList: Array.isArray(s.columnList) ? s.columnList : ['displayName', 'phone'],
          milestoneType: s.milestoneType || 'OPEN',
        }));
      }
    }
  },
};
</script>
<style scoped>
.checkbox-vertical {
  display: flex;
  flex-direction: column;
}
.custom-button-add {
  background-color: #1769d7;
  border: none;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.selected-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.information-file {
  width: 280px;
  border-radius: 4px;
  border: 1px solid #dcdfe9;
}

.process {
  width: 660px;
  border-radius: 4px;
  border: 1px solid #dcdfe9;
}
.color-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 150px;
  margin-left: 10px;
}

.color-box {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  font-weight: bold;
}

.custom {
  border: none;
  background: none;
}
.circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #cf4343;
  background-color: white;
  color: #696b72;
}

.active {
  background-color: #327ae7;
  border: 1px solid #4b9e77;
  color: white;
  font-size: 16px;
}
.value {
  background-color: white;
  border: 1px solid #4b9e77;
  color: #696b72;
  font-size: 16px;
}
.circle.bolded {
  border: 2px solid #0a58c0;
  color: #0a58c0;
  font-weight: 900;
}
.circle.bolded.active {
  background-color: #327ae7;
  color: white;
  border: 2px solid #0a58c0;
}
.custom-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.custom-input {
  width: 560px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  padding: 8px;
}
.counter-pad >>> .el-input__inner {
  padding-right: 60px;
}
.custom-input.active-input {
  border: 1px solid #327ae7;
}
.custom-input1 {
  border: none;
  outline: none;
  border-radius: 4px;
  padding-right: 50px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}
.char-counter {
  display: flex;
  align-items: center;
  right: 5px;
  top: 50%;
  color: #666;
  font-size: 12px;
}
.upload >>> .el-upload {
  width: 100%;
  overflow: hidden;
}

.upload >>> .el-upload-dragger {
  height: 100%;
  width: 100%;
  border: 1px #ffffff solid;
  overflow: hidden;
}

.upload >>> .el-upload-dragger {
  height: 100%;
  width: 100%;
  border: 1px #ffffff solid;
}

.upload.no-click >>> .el-upload {
  cursor: no-drop !important;
}
.open-file {
  height: 150px;
  overflow-y: scroll;
  position: absolute;
  top: 38px;
  right: 0;
  z-index: 999999;
  background: #fff;
  padding: 8px;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}
.upload-input {
  max-height: 32px;
  width: 100%;
  padding: 5px 8px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px dashed #85b1ff;
  background: #d4e4ff;
  color: #327ae7;
}

.upload-input >>> input {
  cursor: pointer;
  border-radius: 4px;
  border: 1px dashed #85b1ff;
  background: #d4e4ff;
  color: #327ae7;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}
</style>

<style>
.milestone-select-EMPTY .el-input__inner { background-color: #f5f5f5 !important; color: #a0a0a0 !important; border: 1px solid #dcdfe9 !important; font-weight: 400; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-OPEN .el-input__inner { background-color: #e1edfd !important; color: #176ad7 !important; border: 1px solid transparent !important; font-weight: 500; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-WON .el-input__inner { background-color: #e6f7eb !important; color: #1e8e3e !important; border: 1px solid transparent !important; font-weight: 500; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-LOST .el-input__inner { background-color: #ffeced !important; color: #d93025 !important; border: 1px solid transparent !important; font-weight: 500; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-EMPTY .el-input__icon, .milestone-select-OPEN .el-input__icon, .milestone-select-WON .el-input__icon, .milestone-select-LOST .el-input__icon { line-height: 26px !important; }
.bg-open-option { color: #176ad7 !important; font-weight: 500; }
.bg-won-option { color: #1e8e3e !important; font-weight: 500; }
.bg-lost-option { color: #d93025 !important; font-weight: 500; }
.legend-dot { display: inline-block; width: 12px; height: 12px; border-radius: 2px; margin-right: 6px; border: 1px solid #cfced4; }
.bg-open-dot { background-color: #e1edfd; border: 1px solid #85b1ff; }
.bg-won-dot { background-color: #e6f7eb; border: 1px solid #5bb974; }
.bg-lost-dot { background-color: #ffeced; border: 1px solid #f28b82; }

.no-icon-message {
  background: white !important;
}
.no-icon-message .el-icon-success {
  display: none !important;
  background: white !important;
}

.no-icon-message .el-message__content {
  margin-left: 0 !important;
  color: black
}
</style>
